/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospects_RenderProspectEmailRequest = {
    language?: prospects_RenderProspectEmailRequest.language;
    /**
     * SenderName is supplied by the client -- the auth middleware exposes only the
     * acting user's id, org id and role, never a display name, so the server cannot
     * derive it. The frontend passes the signed-in Clerk user's full name.
     */
    sender_name?: string;
    template_key: prospects_RenderProspectEmailRequest.template_key;
};
export namespace prospects_RenderProspectEmailRequest {
    export enum language {
        DE = 'de',
        EN = 'en',
        ES = 'es',
        FR = 'fr',
        IT = 'it',
        PT = 'pt',
    }
    export enum template_key {
        INQUIRY_CONFIRMATION = 'inquiry_confirmation',
        TOUR_INVITATION = 'tour_invitation',
        POST_TOUR_FOLLOWUP = 'post_tour_followup',
        REJECTION_NO_AVAILABILITY = 'rejection_no_availability',
        CONTRACT_DISPATCH = 'contract_dispatch',
    }
}

